module.exports = __webpack_public_path__ + "img/oneonone@2x.c8e5f19.jpg";